const API_BASE_URL = process.env.REACT_APP_API_BASE_URL; // ASP.NET Core API URL'niz

export const menuService = {
  // QR kod ID ile QR kod bilgilerini getir (restaurantId, tableNumber vb.)
  getQrCodeById: async (qrCodeId) => {
    const response = await fetch(`${API_BASE_URL}/api/menuqrcodes/${qrCodeId}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) {
      throw new Error(`QR Code bulunamadı! status: ${response.status}`);
    }
    return await response.json();
  },

  // Restoran bilgilerini getir
  getRestaurant: async (qrMenuId, lang = 'tr') => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/restaurants/${qrMenuId}?lang=${encodeURIComponent(lang)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching restaurant:', error);
      // Fallback data if API fails
      return {
        id: "restaurantId",
        name: "Restoran",
        description: "Lezzetli yemekler burada!",
        primaryColor: "#FF6B35",
        logo: "🍽️"
      };
    }
  },

  // Restoran kategorilerini getir
  getCategories: async (qrMenuId, lang = 'tr') => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/categories/restaurant/${qrMenuId}?lang=${encodeURIComponent(lang)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching categories:', error);
      // Fallback categories if API fails
      return [
        { id: 'kahvalt', name: 'Kahvaltılar', icon: '☀️', color: 'bg-yellow-100' },
        { id: 'tostlar', name: 'Tostlar', icon: '🍞', color: 'bg-orange-100' },
        { id: 'burger', name: 'Burger', icon: '🍔', color: 'bg-red-100' },
        { id: 'pastalar', name: 'Pastalar', icon: '🍰', color: 'bg-pink-100' },
        { id: 'icecekler', name: 'İçecekler', icon: '🥤', color: 'bg-blue-100' }
      ];
    }
  },

  // Restoran ürünlerini getir
  getProducts: async (qrMenuId, lang = 'tr') => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/products/restaurant/${qrMenuId}?lang=${encodeURIComponent(lang)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching products:', error);
      // Fallback products if API fails
      return [
        {
          id: '1',
          categoryId: 'burger',
          name: 'Alsancak Burger',
          description: 'Dana eti, cheddar peyniri, marul, domates, özel sos',
          price: 38,
          image: '/MenuResim/alsancak-burger.jpg',
          isVegetarian: false,
          isSpicy: false,
          preparationTime: 15,
          rating: 4.8,
          ingredients: 'Dana eti, cheddar peyniri, marul, domates, soğan, turşu, özel burger sosu',
          calories: 650
        },
        {
          id: '2',
          categoryId: 'burger',
          name: 'Mini Çocuk Burger',
          description: 'Çocuklar için özel hazırlanmış mini burger',
          price: 29,
          image: '/MenuResim/mini-burger.jpg',
          isVegetarian: false,
          isSpicy: false,
          preparationTime: 10,
          rating: 4.6,
          ingredients: 'Dana eti, mild cheddar, marul, domates',
          calories: 450
        },
        {
          id: '3',
          categoryId: 'burger',
          name: 'Veggie Deluxe',
          description: 'Sebze köftesi, avokado, roka, özel vegan sos',
          price: 35,
          image: '/MenuResim/veggie-burger.jpg',
          isVegetarian: true,
          isSpicy: false,
          preparationTime: 12,
          rating: 4.4,
          ingredients: 'Sebze köftesi, avokado, roka, domates, vegan sos',
          calories: 520
        },
        {
          id: '4',
          categoryId: 'burger',
          name: 'Spicy BBQ Burger',
          description: 'Acılı BBQ soslu dana burger, jalapeño',
          price: 42,
          image: '/MenuResim/spicy-burger.jpg',
          isVegetarian: false,
          isSpicy: true,
          preparationTime: 18,
          rating: 4.7,
          ingredients: 'Dana eti, BBQ sos, jalapeño, cheddar, soğan halkası',
          calories: 720
        },
        {
          id: '5',
          categoryId: 'tostlar',
          name: 'Klasik Tost',
          description: 'Kaşar peyniri ve sucuklu tost',
          price: 18,
          image: '/MenuResim/klasik-tost.jpg',
          isVegetarian: false,
          isSpicy: false,
          preparationTime: 8,
          rating: 4.3,
          ingredients: 'Ekmek, kaşar peyniri, sucuk',
          calories: 380
        },
        {
          id: '6',
          categoryId: 'icecekler',
          name: 'Taze Portakal Suyu',
          description: 'Günlük sıkılmış taze portakal suyu',
          price: 15,
          image: '/MenuResim/portakal-suyu.jpg',
          isVegetarian: true,
          isSpicy: false,
          preparationTime: 3,
          rating: 4.9,
          ingredients: 'Taze portakal',
          calories: 120
        }
      ];
    }
  },

  // QR kod erişim logunu kaydet
  logAccess: async (qrCodeId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/menuqrcodes/${qrCodeId}/access`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error logging access:', error);
      // Bu hata kritik değil, sessizce geç
    }
  },

  // QR kod bilgilerini getir
  getQrCodeInfo: async (qrMenuId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/menuqrcodes/restaurant/${qrMenuId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error fetching QR code info:', error);
      throw error;
    }
  },

  // Sipariş oluştur
  createOrder: async (orderData) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/orders`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(orderData),
      });
      
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error creating order:', error);
      throw error;
    }
  },

  // Aktif siparişleri getir (QR menü açıldığında)
  getActiveOrders: async (qrMenuId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/orders/active/${qrMenuId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching active orders:', error);
      // Hata durumunda boş array döndür
      return { orders: [], totalAmount: 0 };
    }
  },

  // Bekleyen siparişleri getir (Restoran için)
  getPendingOrders: async (restaurantId) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/api/orders/restaurant/${restaurantId}/pending`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching pending orders:', error);
      // Hata durumunda boş array döndür
      return [];
    }
  },

  // Onaylanan siparişleri getir (Restoran için)
  getApprovedOrders: async (restaurantId) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/api/orders/restaurant/${restaurantId}/approved`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error('Error fetching approved orders:', error);
      // Hata durumunda boş array döndür
      return [];
    }
  },

  // Siparişi onayla
  approveOrder: async (orderId, userId) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/api/orders/${orderId}/approve`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userId),
      });
      
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error approving order:', error);
      throw error;
    }
  },

  // Siparişi tamamla
  completeOrder: async (orderId, userId) => {
    try {
      const token = localStorage.getItem('authToken');
      
      // C# backend için request body
      // Format: Guid orderId (route), [FromBody] Guid UserId
      // C# tarafında [FromBody] ile direkt Guid alınamaz, bu yüzden DTO objesi gönderiyoruz
      const requestBody = {
        UserId: userId
      };
      
      const response = await fetch(`${API_BASE_URL}/api/orders/${orderId}/complete`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });
      
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error completing order:', error);
      throw error;
    }
  },

  // Siparişi reddet
  rejectOrder: async (orderId, userId, reason) => {
    try {
      const token = localStorage.getItem('authToken');
      
      // Reason boş, null veya undefined ise hata fırlat
      if (!reason || typeof reason !== 'string' || reason.trim() === '') {
        throw new Error('Red sebebi zorunludur ve boş olamaz');
      }
      
      const trimmedReason = String(reason);
      
      // Reason'un kesinlikle dolu olduğundan emin ol
      if (!trimmedReason || trimmedReason.length === 0) {
        throw new Error('Red sebebi zorunludur ve boş olamaz');
      }
      
      // C# backend için request body
      // Format: Guid orderId (route), [FromBody] Guid UserId, [FromBody] string Reason
      // C# tarafında [FromBody] ile birden fazla parametre gönderilemez, bu yüzden DTO objesi gönderiyoruz
      const requestBody = {
        UserId: userId,
        Reason: trimmedReason
      };
      
      console.log('=== REJECT ORDER DEBUG ===');
      console.log('OrderId:', orderId);
      console.log('UserId:', userId, 'Type:', typeof userId);
      console.log('Reason (original):', reason, 'Type:', typeof reason);
      console.log('Reason (trimmed):', trimmedReason, 'Type:', typeof trimmedReason);
      console.log('Reason length:', trimmedReason.length);
      console.log('Request body object:', requestBody);
      const jsonBody = JSON.stringify(requestBody);
      console.log('Request body JSON:', jsonBody);
      console.log('Parsed back:', JSON.parse(jsonBody));
      console.log('========================');
      
      const response = await fetch(`${API_BASE_URL}/api/orders/${orderId}/reject`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: jsonBody,
      });
      
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error rejecting order:', error);
      throw error;
    }
  },

  // Geçmiş siparişleri filtreleme ile getir
  getOrderHistory: async (restaurantId, filters = {}) => {
    try {
      const token = localStorage.getItem('authToken');
      
      // Query string parametrelerini oluştur (sadece dolu olanları ekle)
      const queryParams = new URLSearchParams();
      if (filters.orderNumber) {
        queryParams.append('orderNumber', filters.orderNumber);
      }
      if (filters.createdAt) {
        queryParams.append('createdAt', filters.createdAt);
      }
      if (filters.startDate) {
        queryParams.append('startDate', filters.startDate);
      }
      if (filters.endDate) {
        queryParams.append('endDate', filters.endDate);
      }
      if (filters.status !== null && filters.status !== undefined && filters.status !== '') {
        queryParams.append('status', filters.status);
      }
      
      // Query string'i oluştur
      const queryString = queryParams.toString();
      const url = `${API_BASE_URL}/api/orders/restaurant/${restaurantId}${queryString ? '?' + queryString : ''}`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error('Error fetching order history:', error);
      // Hata durumunda boş array döndür
      return [];
    }
  }
};

export default menuService;
